interface ChipGroupProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export default function ChipGroup({ options, value, onChange, label }: ChipGroupProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {label && <span className="text-xs text-foreground-500">{label}</span>}
      {options.map((option) => {
        const active = option === value;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`rounded-full px-3 py-1 text-xs whitespace-nowrap transition ${
              active
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900"
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}